export const FAVORITE_URL ='/shop/api/favorite/';
export const CART_URL ='/shop/api/ncart/add/';
export const CLEAR_FAVORITE_URL ='/shop/api/favorite/clear/';
export const CLEAR_FAVORITE_GROUP_URL ='/shop/api/favorite/cleargroup/';